import React, { useContext, useState } from "react";
import { message } from "antd";
import { errorMessage, QuestionType } from "../../../../../service/service";
import {
    homeworkTopicSort,
    removeTopics,
    TopicType
} from "../../../../../service/homework";
import usePromiseCallback from "../../../../../utils/usePromiseCallback";
import PaperContext from "../../context";
import { OrderTopicType } from "../..";
import arrayMove from "array-move";
import _ from "underscore";
import { WidgetQuestBlockPure } from "../../../../exam/addExam/components/WidgetQuestBlock";

interface WidgetQuestBlockProps {
    end?: React.ReactNode;
    active?: boolean;
    type: QuestionType;
    list: OrderTopicType[];
    onToggle: (active: boolean) => void;
}

export default function WidgetQuestBlock({
    end,
    type,
    active,
    onToggle,
    list
}: WidgetQuestBlockProps) {
    const { paperId, setTopics, topics, addTopic, lockEdit, loadPaperData } =
        useContext(PaperContext);
    const [selected, setSelected] = useState<TopicType[]>([]);
    const [visible, setVisible] = useState(false);

    const filterTopicByType = (type: QuestionType) => {
        return topics.filter((item: any) => item.topicType === type);
    };

    // 弹出框取消后，清空一切操作
    const handleCancel = () => {
        setVisible(false);
    };

    const delHtmlTag = (str: string) => {
        return str.replace(/<[^>]+>/g, "");
    };

    const onChange = (topic: TopicType) => {
        if (isChecked(topic)) {
            setSelected(selected => {
                return selected.filter(item => item !== topic);
            });
        } else {
            setSelected(selected => {
                return [...selected, topic];
            });
        }
    };

    const isChecked = (topic: TopicType) => {
        return selected.includes(topic);
    };

    const onRemove = usePromiseCallback(() => {
        if (selected.length === 0)
            return Promise.resolve(message.info("请选择要删除的题目!"));

        return removeTopics(selected, paperId)
            .then(() =>
                setTopics(topics.filter(item => !selected.includes(item)))
            )
            .then(() => setSelected([]))
            .then(() => list.length === selected.length && onToggle(false))
            .then(() => !!message.info("删除成功!"))
            .then(() => {
                loadPaperData();
            })
            .catch(e => message.error(errorMessage(e)));
    });

    const onAddClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        if (lockEdit) {
            message.warn("学生已经开始答题, 无法编辑！");
            return;
        }
        onToggle(true);
        addTopic(type);
    };

    const handleSortable = ({
        oldIndex,
        newIndex
    }: {
        oldIndex: any;
        newIndex: any;
    }) => {
        const topicList = [...topics];
        const array = moveArray(
            _.sortBy(
                topicList.filter(topic => topic.topicType === type),
                topic => topic.order
            ),
            oldIndex,
            newIndex
        );
        array.forEach(item => {
            const index = topicList.findIndex(
                topic => topic.tempTopicId === item.tempTopicId
            );
            if (index >= 0) topicList[index] = item;
        });
        homeworkTopicSort(
            paperId,
            array.map(item => item.topicId || item.tempTopicId)
        );
        setTopics(topicList);
    };

    const moveArray = (list: OrderTopicType[], from: number, to: number) => {
        return arrayMove(list, from, to).map((item, index) => {
            item.order = index;
            return item;
        });
    };

    return (
        <WidgetQuestBlockPure
            list={filterTopicByType(type)}
            lockEdit={lockEdit}
            end={end}
            onAddClick={onAddClick}
            type={type}
            visible={visible}
            setVisible={setVisible}
            handleCancel={handleCancel}
            onRemove={onRemove}
            handleSortable={handleSortable}
            isChecked={isChecked}
            delHtmlTag={delHtmlTag}
            onChange={onChange}
        />
    );
}
